import React, { useEffect, useState, useRef } from "react";
import { useQuery, useMutation } from "react-query";
import { useParams } from "react-router-dom";
import DataTable from "../../Components/DataTable/DataTable";
import {
  I2cButton,
  I2cAlert,
  I2cDataTable,
} from "@webcomponents/i2cwebcomponents/dist/react";
import ProgramTarget from "./ProgramTargetCellRenderer";
import ProgramType from "./ProgramTypeCellRenderer";
import FormsService from "../../Services/FormsAssignmentService";
import { OverlayLoader } from "../../Components/Loader/Loader";

const AssignProjects = ({ closeModal = () => null, onAssignSuccess }) => {
  const [page, setPage] = useState(1);
  const { id: userId } = useParams();
  const [reloadComponent, setReloadComponent] = useState(false);
  const [projectStatus, setProjectStatus] = useState(false);
  const {
    data: projects,
    isFetching,
    isLoading,
    refetch: refetchUsers,
  } = useQuery(
    ["projects", page, userId],
    () => FormsService.getUserOtherForms(userId, page),
    {
      refetchOnWindowFocus: false,
    },
  );
  const [rowDataa, setRowDataa] = useState(projects?.data?.forms);
  const [gridOptions, setGridOptions] = useState({});

  const table = useRef(null);
  // const { data: projectsData, total, per_page } = projects?.data?.data ?? {};
  // const projectsData = projects?.data.data.data ?? [];
  const columnDefs = [
    {
      field: "",
      headerName: " ",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      showDisabledCheckboxes: true,

      flex: 1,
      minWidth: 68,
      suppressMenu: true,
    },
    {
      field: "form_name",
      headerName: "Client Name",
      sortable: true,
      flex: 1,
      minWidth: 178,
      suppressMenu: true,
    },
    {
      field: "form_type",
      headerName: "Program Type",
      cellRenderer: ProgramType,
      sortable: true,
      flex: 1,
      minWidth: 178,
      suppressMenu: true,
    },
    {
      field: "created_at",
      headerName: "Target Date",
      cellRenderer: ProgramTarget,
      sortable: true,
      flex: 1,
      minWidth: 178,
      suppressMenu: true,
    },
  ];

  // Define the delete session mutation hook
  const assignProject = useMutation({
    mutationFn: async (payload) => {
      return await FormsService.assignForms(userId, payload?.ids ?? []);
    },
    onSuccess: (data) => {
      // if(data.data.status == false){
      //   setReloadComponent(true);
      //   onAssignSuccess();
      // }
      setReloadComponent(true);
      onAssignSuccess();
    },
    onError: (e) => {
      console.log("api error");
    },
  });
  // Function to handle session deletion
  const handleAssignProjects = async (selectedRows) => {
    try {
      const ids = selectedRows.map((row) => row.id);
      const payload = {
        userId,
        ids,
      };
      await assignProject.mutate(payload);
    } catch (error) {
      console.log(error);
    } finally {
      closeModal();
    }
  };
  if (reloadComponent) {
    return (
      <AssignProjects
        closeModal={closeModal}
        onAssignSuccess={onAssignSuccess}
      />
    );
  }
  const noData = [
    {
      heading: "No records found",
      description: "No records were found.",
      type: "noData",
      icon: "outline-info-circle",
      iconColor: "var(--i2c-color-primary-600)",
    },
  ];

  // if (isLoading || isFetching) return <OverlayLoader />;
  return (
    <React.Fragment>
      <div className="dTable">
        <div className="dTable-label">
          <span>Select Project(s)</span>
        </div>
        <DataTable
          columnDefs={columnDefs}
          rowData={projects?.data?.forms ?? []}
          title={""}
          noData={noData}
          pageSize={6}
          currentPage={page}
          setCurrentPage={setPage}
          total={projects?.data?.forms?.length}
          description={""}
          closeModal={closeModal}
          onAssign={handleAssignProjects}
          tableDataApi={table}
          rowSelection="multiple"
        />
      </div>
      <footer slot="footer">
        <I2cButton slot="footer" variant="secondary gray" onClick={closeModal}>
          Cancel
        </I2cButton>

        {projects?.data?.forms.length !== 0 && (
          <I2cButton
            slot="footer"
            variant="primary"
            onClick={() => {
              const api = table.current.getGridApi();
              const selectedNodes = api.getSelectedNodes();
              const selectedRows = selectedNodes.map((node) => node.data);
              handleAssignProjects(selectedRows);
            }}
          >
            Assign
          </I2cButton>
        )}
      </footer>
    </React.Fragment>
  );
};

export default AssignProjects;
